import { api } from '@/config/api';

export interface SavedFilter {
  filterUid: string;
  scope: string;
  name: string;
  description?: string;
  filter: Record<string, unknown>;
  isShared?: boolean;
  isDefault?: boolean;
  isSmart?: boolean;
  lastCount?: number;
  lastEvaluatedAt?: string;
  ownerUserUid: string;
  createdAt: string;
  updatedAt: string;
}

export interface CreateSavedFilterPayload {
  scope: string;
  name: string;
  description?: string;
  filter?: Record<string, unknown>;
  isShared?: boolean;
  isDefault?: boolean;
  isSmart?: boolean;
}

export interface UpdateSavedFilterPayload {
  name?: string;
  description?: string;
  filter?: Record<string, unknown>;
  isShared?: boolean;
  isDefault?: boolean;
  isSmart?: boolean;
}

export const savedFiltersService = {
  list: async (scope: string): Promise<SavedFilter[]> =>
    (await api.get('/slighter_crm/saved-filters', { params: { scope } })).data,

  create: async (p: CreateSavedFilterPayload): Promise<SavedFilter> =>
    (await api.post('/slighter_crm/saved-filters', p)).data,

  update: async (filterUid: string, p: UpdateSavedFilterPayload): Promise<SavedFilter> =>
    (await api.patch(`/slighter_crm/saved-filters/${filterUid}`, p)).data,

  remove: async (filterUid: string): Promise<void> => {
    await api.delete(`/slighter_crm/saved-filters/${filterUid}`);
  },

  /**
   * Bulk-evaluate live counts for smart filters. Pass the visible filter UIDs;
   * the backend caches each result for 30s, so polling at any cadence is safe.
   * Non-smart filters return null in the map (caller renders no badge).
   */
  evaluateCounts: async (filterUids: string[]): Promise<Record<string, number | null>> =>
    (await api.post('/slighter_crm/saved-filters/counts', { filterUids })).data,
};
